import { InstrumentationBase } from '@opentelemetry/instrumentation';
import { isUrlIgnored } from '@opentelemetry/core';
import { AttributeNames } from '@opentelemetry/instrumentation-document-load';
import { SemanticAttributes } from '@opentelemetry/semantic-conventions';
import { hasKey, PerformanceTimingNames, addSpanNetworkEvents } from '@opentelemetry/sdk-trace-web';

class CloudObservationResourceInstrumentation extends InstrumentationBase {
    constructor(config) {
        super('@heytap/cloud-observation-instrumentation-resource', "2.1.1", config || {});
        this._noCollectType = ['xmlhttprequest', 'fetch'];
    }
    init() { }
    _getConfig() {
        return this._config;
    }
    _startSpan(spanName, performanceName, entries) {
        if (hasKey(entries, performanceName) &&
            typeof entries[performanceName] === 'number') {
            const span = this.tracer.startSpan(spanName, {
                startTime: entries[performanceName],
            });
            // span.setAttribute(AttributeNames.COMPONENT, this.component);
            return span;
        }
        return undefined;
    }
    _endSpan(span, performanceName, entries) {
        // span can be undefined when entries are missing the certain performance - the span will not be created
        if (span) {
            if (hasKey(entries, performanceName)) {
                span.end(entries[performanceName]);
            }
            else {
                // just end span
                span.end();
            }
        }
    }
    isSupported() {
        if (typeof PerformanceObserver === 'undefined' ||
            !PerformanceObserver.supportedEntryTypes)
            return false;
        return true;
    }
    _initResourceSpan(resource) {
        if (isUrlIgnored(resource.name, this._getConfig().ignoreUrls))
            return;
        if (this._noCollectType.includes(resource.initiatorType))
            return;
        const span = this._startSpan(AttributeNames.RESOURCE_FETCH, PerformanceTimingNames.FETCH_START, resource);
        if (span) {
            span.setAttribute(SemanticAttributes.HTTP_URL, resource.name);
            span.setAttribute(SemanticAttributes.HTTP_STATUS_CODE, resource.responseStatus);
            addSpanNetworkEvents(span, resource);
            this._endSpan(span, PerformanceTimingNames.RESPONSE_END, resource);
        }
    }
    _collectPerformance(list) {
        const resources = list.getEntries();
        resources.forEach((resource) => {
            this._initResourceSpan(resource);
        });
    }
    _onDocumentLoaded() {
        window.setTimeout(() => {
            this._observer = new PerformanceObserver((list) => this._collectPerformance(list));
            this._observer.observe({ entryTypes: ['resource'] });
        }, 10);
    }
    bufferFull() {
        performance.clearResourceTimings();
    }
    _waitForPageLoad() {
        // 等PageLoad后才开启监听resource
        // （部分资源在opentelemetry-instrumentation-document-load会被上报）
        if (window.document.readyState === 'complete') {
            this._onDocumentLoaded();
        }
        else {
            this._onDocumentLoaded = this._onDocumentLoaded.bind(this);
            window.addEventListener('load', this._onDocumentLoaded);
        }
    }
    enable() {
        if (!this.isSupported()) {
            this._diag.debug('Environment not supported');
            return;
        }
        window.removeEventListener('load', this._onDocumentLoaded);
        this._waitForPageLoad();
        performance.addEventListener('resourcetimingbufferfull', this.bufferFull);
    }
    disable() {
        window.removeEventListener('load', this._onDocumentLoaded);
        this._observer.disconnect();
        performance.removeEventListener('resourcetimingbufferfull', this.bufferFull);
    }
}

export { CloudObservationResourceInstrumentation };
